module.exports = __webpack_public_path__ + "static/bano-a99734e6f75f6b93dea72d9674237111.jpg";